import { UNGROUPED_RESOURCES_GROUP_ID } from '@/console/features/groups/components/group-list/group-list.constants';
import { api } from '@/shared/redux/api/_generated/api/integration-api.generated';

export const integrationsApi = api.enhanceEndpoints({
  addTagTypes: ['Integration', 'Repository', 'Groups'],
  endpoints: {
    ReadAllIntegrations: {
      providesTags: (_, __, args) => {
        const tags = [{ type: 'Integration' as const, id: 'LIST' }];
        const filteredGroup = args?.filter?.groupId;
        const groupId = filteredGroup?.contains ?? UNGROUPED_RESOURCES_GROUP_ID;
        if (filteredGroup) {
          return [...tags, { type: 'Groups' as const, id: groupId }];
        }
        return tags;
      },
    },
    CreateIntegration: {
      invalidatesTags: () => [
        { type: 'Integration' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    DeleteIntegration: {
      invalidatesTags: () => [
        { type: 'Integration' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    SyncIntegration: {
      invalidatesTags: () => [{ type: 'Repository' as const, id: 'LIST' }],
    },
    UpdateIntegration: {
      invalidatesTags: (_, __, args) => [
        { type: 'Integration' as const, id: args.integrationId },
        'Groups' as const,
      ],
    },
    ReadAllGitRepositories: {
      providesTags: [{ type: 'Repository' as const, id: 'LIST' }],
    },
    UpdateGitRepository: {
      invalidatesTags: () => [{ type: 'Repository' as const, id: 'LIST' }],
    },
    ReadGroupedIntegrationsCount: {
      providesTags: (_, __, args) => [
        { type: 'Groups' as const, id: args.groupId },
      ],
    },
    ReadGroupedIntegrationCounts: {
      providesTags: (result) =>
        (result?.readGroupedIntegrationCounts ?? []).map((count) => ({
          type: 'Groups' as const,
          id: count.groupId,
        })),
    },
    ReadUngroupedIntegrationsCount: {
      providesTags: [
        { type: 'Groups' as const, id: UNGROUPED_RESOURCES_GROUP_ID },
      ],
    },
  },
});

export const {
  useUpdateIntegrationMutation,
  useDeleteIntegrationMutation,
  useSyncIntegrationMutation,
  useCreateIntegrationMutation,
  useReadAllIntegrationsQuery,
  useUpdateGitRepositoryMutation,
  useReadAllIntegrationNamesQuery,
  useReadAllGitRepositoriesQuery,
  useReadGitHubRepositoryQuery,
  useLazyReadGitHubRepositoryQuery,
  useReadGroupedIntegrationsCountQuery,
  useReadGroupedIntegrationCountsQuery,
  useReadUngroupedIntegrationsCountQuery,
  useLazyGenerateGithubInstallUrlQuery,
} = integrationsApi;
